

import React from 'react'
import ListItem from '../presents/ListItem'

const ListItemImageContainer = ({
    imgKey='img',
    itemType,
    itemData,
    additionalClass,
    isSelected,
    pathnameEdit,
    onDelete,
}) => {
    let backgroundImage = 'none'

    if(itemData[imgKey] && itemData[imgKey].url) {
        backgroundImage =  `url(${itemData[imgKey].url})`
    }

    const styles = {
        backgroundImage: backgroundImage
    }


    return <ListItem
        title={false}
        styles={styles}
        type={itemType}
        additionalClass={additionalClass}
        isSelected={isSelected}
        pathnameEdit={pathnameEdit}
        onDelete={onDelete}
    />
}

export default ListItemImageContainer